<template>
  <div class="librarySearch clearfix" :class="type==0?'platform':'library'">
    <div class="center clearfix">
      <input type="text" :class="type==0?'platform_input':'library_input'" placeholder="请输入搜索关键字"
             class="librarySearchInput l" v-model="keywordInput" maxlength="20"/>
      <div class="librarySearchBtn l themeBg" @click="search">搜索</div>
      <div v-if="type!=1 && !nosearch" class="highSearch" @click="highSearch()">高级搜索</div>
    </div>
    <div v-if="type==1 && !nosearch" class="highSearch website libSearColor" @click="highSearch()">高级搜索
    </div>
  </div>
</template>

<script>
  import {store} from '../store/store'
  export default {
    name: 'search',
    components: {
    },
    data() {
      return {
        type: store.webType, /*0: 平台，1：图书馆*/
        keywordInput: '',
      }
    },
    created() {
          this.keywordInput = this.$route.query.searchStr || '';
    },
    props: ['resource','nosearch'],
    methods: {
      search() {
        var keywordInput=this.keywordInput;
        if(keywordInput.trim()==""){
            var searchType =this.$route.query.type;
            if (searchType == 1) {
                this.$router.push({path: '/book/1'});
            } else if (searchType == 2) {
                this.$router.push({path: '/book/2'});
            } else if (searchType == 3) {
                this.$router.push({path: '/librarylist'});
            } else if (searchType == 4) {
                this.$router.push({path: '/activitylist'});
            } else if (searchType == 5) {
                this.$router.push({path: '/informationlist'});
            }
              return;
        }
        this.$emit('search',keywordInput);
      },
      //高级搜索
      highSearch(){
        this.$emit('highSearch');
      },
    }
  }
</script>

<style scoped lang="sass">
    /*.webdefault
      .highSearch
        color: $themecolor1
        background-image: url("../assets/images/search_logo.png")*/
    .librarySearch
      width: 100%
      line-height: 40px
    .highSearch
      margin:
        top: 28px
      padding:
        right: 30px
      height: 18px
      line-height: 18px
      text-align: center
      color: $color-333
      cursor: pointer
      background: url("../assets/images/web2_search_logo.png") right center no-repeat

    /*.libSearColor
      color: $themecolor1
      background-image: url("../assets/images/search_logo.png")*/
    .platform
      margin: 0 auto
      padding:
        top: 36px
        bottom: 36px
      width: $container-width
      background: #fff
      .librarySearchBtn
        width: 80px
        height: 42px
        line-height: 42px
      .highSearch
        display: inline-block
        vertical-align: middle
        margin:
          left: 20px
          top: 0
      .center
        margin: 0 auto
        width: 880px
        line-height: 40px
    .library
      margin:
        bottom: 42px
      padding:
        top: 54px
      height: 206px
      background: url("../assets/images/search_bg.jpg") no-repeat
      .librarySearchBtn
        width: 113px
        height: 52px
        line-height: 52px
        letter-spacing: 10px
        text-indent: 10px
      .center
        margin: 0 auto
        width: 800px!important

    .librarySearchInput
      width: 686px
      border: none
      font-size: 16px
      text-indent: 10px
      text-align: left
      color: $color-333
    .library_input
      height: 52px
      border: none
    .platform_input
      height: 42px
      border: 1px solid #e0e0e0
      border:
        right: none

    .librarySearchBtn
      text-align: center
      color: #fff
      background: $themecolor1
      cursor: pointer
    .highSearch_platform
      color: $color-333
    .website
      margin:
        left: auto
        right: auto
      width: 94px
</style>
